<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout search-area">
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>검색 조건
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>대상학기</th>
              <td>
                <select v-model="query.semesterCd" name="semesterCd">
                  <option value="">선택</option>
                  <option v-for="item in semesterCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                    {{ item }}
                  </option>
                </select>
              </td>
              <th>장학대상자학번</th>
              <td><input type="text" v-model="query.substituteHakbun" v-on:keyup.enter="searchQuery"></td>
              <th>장학대상자성명</th>
              <td><input type="text" v-model="query.substituteNm" v-on:keyup.enter="searchQuery"></td>
              <th>기부자교우번호</th>
              <td><input type="text" v-model="query.memberNo" v-on:keyup.enter="searchQuery" maxlength="8"></td>
              <th>기부자성명</th>
              <td><input type="text" v-model="query.memberHnm" v-on:keyup.enter="searchQuery"></td>
            </tr>
            <tr>
              <th>테이블번호</th>
              <td><input type="text" v-model="query.depositeTableNo" v-on:keyup.enter="searchQuery"></td>
              <th>발급번호</th>
              <td><input type="text" v-model="query.issuedNo" v-on:keyup.enter="searchQuery"></td>
              <th>기부자참석여부</th>
              <td>
                <label><input type="radio" v-model="query.depositeAttendYn" name="depositeAttendYn" value="Y" v-on:keyup.enter="searchQuery">Y</label>
                <label><input type="radio" v-model="query.depositeAttendYn" name="depositeAttendYn" value="N" v-on:keyup.enter="searchQuery">N</label>
              </td>
              <th>학생참석여부</th>
              <td>
                <label><input type="radio" v-model="query.studentAttendYn" name="studentAttendYn" value="Y" v-on:keyup.enter="searchQuery">Y</label>
                <label><input type="radio" v-model="query.studentAttendYn" name="studentAttendYn" value="N" v-on:keyup.enter="searchQuery">N</label>
              </td>
              <th>대참여부</th>
              <td>
                <label><input type="radio" v-model="query.substituteYn" name="substituteYn" value="Y" v-on:keyup.enter="searchQuery">Y</label>
                <label><input type="radio" v-model="query.substituteYn" name="substituteYn" value="N" v-on:keyup.enter="searchQuery">N</label>
              </td>
            </tr>
            <tr>
              <th>구분</th>
              <td colspan="9">
                <label><input type="radio" v-model="query.applyGb" name="applyGb" value="1" v-on:keyup.enter="searchQuery">개인 명의</label>
                <label><input type="radio" v-model="query.applyGb" name="applyGb" value="2" v-on:keyup.enter="searchQuery">단체 명의</label>
              </td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="searchQuery">
            <md-icon>check</md-icon>검 색
          </md-button>
          <md-button class="md-default md-sm" @click="resetQuery">
            <md-icon>clear</md-icon>초기화
          </md-button>
          <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]">
            <md-icon>get_app</md-icon>Excel 다운로드
          </md-button>
          <md-button class="md-warning md-sm" @click="deleteRows">
            <md-icon>clear</md-icon>삭제
          </md-button>
        </md-card-actions>
      </md-card>

      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>assignment</md-icon>
            검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>

          <grid ref="ApplyDonorList"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @response="response"
          ></grid>

        </md-card-content>
      </md-card>
    </div>

  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import Swal from "sweetalert2";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  components: {
    grid: Grid
  },

  props: {
  },

  created() {
    this.getSemesterCdList();
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  data() {
    return {
      query : {
        semesterCd : null,
        substituteHakbun : null,
        substituteNm : null,
        memberNo : null,
        memberHnm : null,
        applyGb : null,
        depositeTableNo : null,
        issuedNo : null,
        depositeAttendYn : null,
        studentAttendYn : null,
        substituteYn : null
      },
      semesterCdList : [],
      applyGbNm : {
        '1' : '개인명의',
        '2' : '교우자녀',
        '3' : '교우회(장학)'
      },
      gridProps: {},
      pagination: {
        perPage: 500,
        page: 1,
        perPageOptions: [800,500, 200, 100, 50, 20],
        total: 0
      }
    };
  },
  methods: {
    getSemesterCdList() {
      kuaaFnc.fncSemesterCodes(null, res => {
        this.semesterCdList = res.data.data.contents;
      });
    },
    resetQuery(){
      this.query = {
        semesterCd : null,
        substituteHakbun : null,
        substituteNm : null,
        memberNo : null,
        memberHnm : null,
        applyGb : null,
        depositeTableNo : null,
        issuedNo : null,
        depositeAttendYn : null,
        studentAttendYn : null,
        substituteYn : null
      }
    },
    searchQuery (){
      this.$refs.ApplyDonorList.invoke("readData", 1, this.query);
    },
    initGrid() {
      let _this = this;
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_SCHA_MAPPING_LIST, false, this.pagination, ['rowNum', 'checkbox']);
      this.gridProps['el'] = this.$refs.ApplyDonorList;
      this.gridProps['columns']= [
          {header: '장학금구분', name: 'applyGb', align : 'center', width:100, sortable: true,
            formatter(value) {
              if(value.value){
                return _this.applyGbNm[value.value];
              }else{
                return '';
              }
            }
          },
          {header: '지급년도/학기', name: 'semesterCdNm', align : 'center', width:120, sortable: true},
          {header: '기부자교우번호', name: 'memberNo', align : 'center', width:120, sortable: true},
          {header: '기부자명', name: 'memberHnm', align : 'center', width:120, sortable: true},
          {header: '기부자학과', name: 'classNm', align : 'center', width:120, sortable: true},
          {header: '기부자학번', name: 'hakbun', align : 'center', width:120, sortable: true},
          {header: '기부자참석여부', name: 'depositeAttendYn', align : 'center', width:120, sortable: true,
            editor: {
              type: 'radio',
              options : {
                listItems : [{
                  text : 'Y',
                  value : 'Y'
                }, {
                  text : 'N',
                  value : 'N'
                }]
              }
            },
            onAfterChange(e) {
              _this.editAttend(e);
            }
          },
          {header: '테이블번호(기부자)', name: 'depositeTableNo', align : 'center', width:130, sortable: true,
            editor: {
              type: 'text'
            },
            onAfterChange(e) {
              _this.editRow(e);
            }
          },
          {header: '대참여부', name: 'substituteYn', align : 'center', width:120, sortable: true,
            editor: {
              type: 'radio',
              options : {
                listItems : [{
                  text : 'Y',
                  value : 'Y'
                }, {
                  text : 'N',
                  value : 'N'
                }]
              }
            },
            onAfterChange(e) {
              _this.editRow(e);
            }
          },
          {header: '대참자이름', name: 'substituteNm', align : 'center', width:120, sortable: true,
            editor: {
              type: 'text'
            },
            onAfterChange(e) {
              _this.editRow(e);
            }
          },
          {header: '대참자학과', name: 'substituteCollageSCd', align : 'center', width:120, sortable: true,
            editor: {
              type: 'text'
            },
            onAfterChange(e) {
              _this.editRow(e);
            }
          },
          {header: '대참자학번', name: 'substituteHakbun', align : 'center', width:120, sortable: true,
            editor: {
              type: 'text'
            },
            onAfterChange(e) {
              _this.editRow(e);
            }
          },
          {header: '대참자직위', name: 'substituteLevelNm', align : 'center', width:120, sortable: true,
            editor: {
              type: 'text'
            },
            onAfterChange(e) {
              _this.editRow(e);
            }
          },
          {header: '발급번호', name: 'IssuedNo', align : 'center', sortable: true,
            editor: {
              type: 'text'
            },
            onAfterChange(e) {
              _this.editRow(e);
            }
          },
          {header: '학생참석여부 ', name: 'studentAttendYn', align : 'center', width:120, sortable: true,
            editor: {
              type: 'radio',
              options : {
                listItems : [{
                  text : 'Y',
                  value : 'Y'
                }, {
                  text : 'N',
                  value : 'N'
                }]
              }
            },
            onAfterChange(e) {
              _this.editRow(e);
            }
          },
          {header: '테이블번호(학생)', name: 'studentAttendTableNo', align : 'center', width:130, sortable: true,
            // editor: {
            //   type: 'radio',
            //   options : {
            //     listItems : [{
            //       text : 'Y',
            //       value : 'Y'
            //     }, {
            //       text : 'N',
            //       value : 'N'
            //     }]
            //   }
            // },
            // onAfterChange(e) {
            //   _this.editRow(e);
            // }
            editor: {
              type: 'text'
            },
            onAfterChange(e) {
              _this.editRow(e);
            }
          },
          {header: '학생이름', name: 'nm', align : 'center', width:120, sortable: true},
          {header: '학생학과', name: 'collegeSCdNm', align : 'center', width:120, sortable: true},
          {header: '학생학번', name: 'schaHakbun', align : 'center', width:120, sortable: true},
          {header: '학생학년', name: 'collegeSemesterCdNm', align : 'center', width:120, sortable: true},
          {header: 'applySeqNo', name: 'applySeqNo', hidden: true}
        ];
      this.gridProps['columnOptions'].frozenCount = 6;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.ApplyDonorList, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.$refs.ApplyDonorList.invoke("refreshLayout");
    },
    editRow(e){
      let targetRow = this.$refs.ApplyDonorList.invoke('getRow',e.rowKey);

      if(targetRow){
        let modalOptions = kuaaFnc.getSwalModaloptions();
        kuaaApi.sendServer(
          URL_CONST.SAVE_SCHA_MAPPING,
          targetRow,
          "post",
          response => {
            if (response.data.success){
              modalOptions.html = `저장 되었습니다.`;
              this.searchQuery();
              Swal.fire(modalOptions);
            } else {
              modalOptions.html = `저장 실패 하였습니다.`;
              Swal.fire(modalOptions);
            }
          }
        );
      }
    },
    editAttend(e){
      let targetRow = this.$refs.ApplyDonorList.invoke('getRow',e.rowKey);

      if(targetRow){
        let modalOptions = kuaaFnc.getSwalModaloptions();
        kuaaApi.sendServer(
          URL_CONST.SAVE_SCHA_ATTEND,
          targetRow,
          "post",
          response => {
            if (response.data.success){
              modalOptions.html = `저장 되었습니다.`;
              this.searchQuery();
              Swal.fire(modalOptions);
            } else {
              modalOptions.html = `저장 실패 하였습니다.`;
              Swal.fire(modalOptions);
            }
          }
        );
      }
    },
    deleteRows (){

      let checkedRows = this.$refs.ApplyDonorList.invoke('getCheckedRows');

      if(checkedRows.length < 1){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'삭제할 목록을 선택 해 주세요'}));
        return;
      }

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "삭제 하시겠습니까?"
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          let params = [];
          checkedRows.forEach((obj)=>{
            params.push({
              applySeqNo : obj.applySeqNo,
              memberNo : obj.memberNo,
              semesterCd : obj.semesterCd
            });
          });
          kuaaApi.sendServer(
            URL_CONST.DELETE_SCHA_MAPPING_LIST,
            params,
            "post",
            response => {
              let modalOptions = kuaaFnc.getSwalModaloptions();
              if (response.data.success){
                modalOptions.html = `삭제 되었습니다.`;
                Swal.fire(modalOptions);
                this.searchQuery();
              } else {
                modalOptions.html = `삭제 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );

        }
      });
    },
    downloadExcel() {
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '장학증서 수여식 관리';
      kuaaApi.requestFileDownload(
          URL_CONST.SCHA_APPLY_MAPPING_EXCEL_DOWNLOAD,
          this.query,
          '장학증서 수여식 관리.xlsx',
          response => {
          }
      );
    }
  }
};
</script>

<style>

</style>